export const customTextStyle = {
  blackText: {
    color: 'black',
  },
  noWrapText: {
    whiteSpace: 'noWrap',
  },
} as const;

export const baseBoxStyle = {
  WrapperFlex: {
    display: 'flex',
    gap: 3,
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
} as const;
